import styled from 'styled-components'
import { CampaignStatus } from '@/types/campaign/campaign-status/campaign-status'


export const ProgressContainer = styled.div`
  display: flex;
  width: 100%;
  height: 26px;
  position: relative;
  border-radius: 24px;
  background: ${({ theme }) => theme?.colors?.theme?.appBg};
`

export const ProgressBarOuter = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 24px;
  padding: 5px;
  display: flex;
  justify-content: center;
  box-shadow: inset -4px 4px 6px rgba(0, 0, 0, 0.5);
  background-color: ${({ theme }) => theme?.colors?.theme?.appBg};
`

export const ProgressBarBackground = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 24px;
  display: flex;
  background: ${({ theme }) => theme?.colors?.theme?.appBg};
`

export const ProgressBarInner = styled.div<{
  $progress: number
  $status: CampaignStatus
}>`


  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  border-radius: ${(props) => (props.$progress === 0 ? '0px' : '24px')};
  color: #fff;
  background-color: ${({ $status, theme }) => {
    switch ($status) {
      case 'completed':
        return theme?.colors?.theme?.success;
      case 'expired':
        return theme?.colors?.text?.muted;
      case 'inCourse':
        return theme?.colors?.theme?.brandColor3;
      case 'comingUp':
        return theme?.colors?.theme?.brandColor3;
      default:
        return theme?.colors?.theme?.brandColor3;
    }
  }};
  text-align: center;
  transition: width 0.5s ease;
  box-shadow: ${({ $status, theme }) =>
    $status === 'completed'
      ? `0px 0px 10px -1px ${theme?.colors?.theme?.success}`
      : 'none'
  };

`

export const ProgressText = styled.div<{ $status: CampaignStatus }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 0.75rem;
  line-height: 15.88px;
  color: ${({ $status, theme }) => $status === 'completed' ? '#000' : theme?.colors?.text?.headings};
  pointer-events: none;
  font-weight: 600;
`

export const Subtitle = styled.div`
  overflow: hidden;
  color: ${({ theme }) => theme?.colors?.theme?.brandColor3};
  font-family: 'Red Hat Display', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;